import React from "react";
import { Button, Dialog, Icon } from "components";
import { useTranslation } from "react-i18next";
import { saveAs } from "file-saver";
import { types, utils } from "./duck";
import styles from "./VideoPreviewer.module.css";

const VideoPreviewer: React.FC<types.VideoPreviewerProps> = ({
  opened,
  onCloseCallback,
  video,
  onUploadCallback,
}) => {
  const { t } = useTranslation();

  const handleDownLoad = (): void => {
    if (video) {
      saveAs(video, utils.getDefaultVideoName());
    }
  };

  const handleUpload = (): void => {
    if (video) {
      const file = new File([video], utils.getDefaultVideoName(), {
        type: video.type,
      });
      onUploadCallback(file);
    }
  };

  return (
    <Dialog
      title={t("feedback.screencast")}
      opened={opened}
      onClose={onCloseCallback}
      className={styles.modal}
    >
      {video && (
        // added eslint ignore because the recorded video doesn't have any tracks
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video
          controls
          src={URL.createObjectURL(video)}
          className={styles.video}
        />
      )}

      <div className={styles.controls}>
        <Button
          variant="clear"
          prefix={<Icon name="download-outlined" />}
          className={styles.controlDownload}
          onClick={handleDownLoad}
        >
          {t("feedback.download")}
        </Button>
        <Button onClick={handleUpload}>{t("feedback.upload")}</Button>
      </div>
    </Dialog>
  );
};

export default VideoPreviewer;
